import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { KbCompareService } from 'src/app/services/feature/kb-compare/kb-compare.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';

@Component({
  selector: 'app-check-box-compare',
  templateUrl: './check-box-compare.component.html',
  styleUrls: ['./check-box-compare.component.scss'],
  standalone: false
})
export class CheckBoxCompareComponent {
  @Input('product') product: any;
  idneedToBeUnchecked: any;
  disablingCheckbox: any;
  myObject: any;
  arrData: any[];
  private destroy$ = new Subject<void>();
  constructor(public compareService: KbCompareService,
    public cdr: ChangeDetectorRef) { }
  ngOnChanges() {
    this.myObject = { ...this.product };

  }
  ngOnInit() {
    this.compareService.shouldUncheckCheckbox$.pipe(takeUntil(this.destroy$)).subscribe((id) => {
      if (id == this.myObject.code) {
        this.myObject.isCompare = false;
        this.cdr.detectChanges()
      } else if (id == 0) {
        this.myObject.isCompare = false;
        this.cdr.detectChanges()
      }
    })
    this.compareService.compareData.map((y) => {
      if (y.code == this.myObject.code) {
        this.myObject.isCompare = true;
      } 
    })
    this.compareService.data$?.pipe(takeUntil(this.destroy$)).subscribe((arrdata) => {
      if (arrdata) {
        this.arrData = arrdata[0];
        this.arrData.map((x) => {
          if (x.code == this.myObject.code) {
            this.myObject.isCompare = true;
          } 
        })
        if (arrdata[0].length >= 4) {
          this.disablingCheckbox = true;

        }
        else {
          this.disablingCheckbox = false;
        }
      }
    })
  }
  addCompare(arg: any, isSelected) {

    this.compareService.setData(arg, isSelected);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
